let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7A8wH")).then(() => parcelRequire('6teG9'));